'use client';

import React from 'react';

export default function TopBar() {
  return (
    <div className="fixed top-0 left-0 w-full z-50 bg-[#1e1e1e] border-b border-[#b5973a]/40 h-[50px] flex items-center justify-center">
      <a
        href="https://book.housecallpro.com/book/Gorgis-Air-conditioning-and-heating/8d64616590bd4fe49c1a93f43f1cbfae"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#b5973a] hover:bg-[#d4aa4a] text-white border-2 border-[#d4aa4a] px-8 py-2 font-sans font-bold text-sm tracking-widest uppercase transition-colors duration-300 book-btn-pulse rounded-sm"
      >
        BOOK ONLINE — FIRST APPOINTMENT FREE
      </a>
    </div>
  );
}
